<template>
  <v-app>
    <NavBar />
    <section style="background: #e8eaff; padding-top: 50px">
      <v-row class="justify-center mt-16" style="margin-left:0 !important; margin-right:0 !important;">
        <v-col cols="10" xs="8" sm="8" md="6" class="text-center title-main">
          <img
            class="image-subscription left"
            src="@/assets/images/subscription/warning.svg"
          />
          <p
            id="content-t"
            class="change-font font-weight-bold title"
            style="z-index: 1"
          >
            Sorry, payment failed!
          </p>
          <p class="change-font grey-color" style="z-index: 1; font-size: 18px;">
            Looks like we encountered an error.<br>Please try again.
            If you continue to have issues, try another payment method
          </p>
          <div>
            <a href="/pricing.html" class="save-btn v-btn">TRY AGAIN</a>
          </div>
        </v-col>
      </v-row>
    </section>
    <div class="mt-12 mb-8">
      <v-container>
        <Footer class="justify-center" />
      </v-container>
    </div>
  </v-app>
</template>

<script>
import NavBar from '@/views/NavBar'
import Footer from '@/views/Footer'
export default {
  name: 'Failed',
  components: {
    NavBar,
    Footer
  },
  data() {
    return {}
  },
  computed: {
    isDesktop() {
      return this.$vuetify.breakpoint.mdAndUp
    }
  },
  mounted() {},
  methods: {}
}
</script>

<style lang="scss">
.change-font {
  font-family: 'Raleway', sans-serif;
}
.ok-btn {
  background: #7261c9 !important;
}
.image-subscription {
  widows: 10%;
  height: 10%;
}
.grey-color {
  color: #474749;
}

.title-main .title{
  font-size: 42px !important;
  line-height: 3.5rem;
}
.title-main .subtitle{
  font-size: 30px !important;
}

@media (max-width: 640px) {
  .title-main .title{
    font-size: 36px !important;
    line-height: 3rem;
  }
  .title-main .subtitle{
    font-size: 24px !important;
    line-height: 2rem;
  }
}
</style>
